import {inject, Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {
    ComputeSensitivitiesRequest,
    DealApiService,
    DealSensitivity,
    DealSensitivityOverview,
} from "../generated-sources/api/deal";

@Injectable({
    providedIn: "root"
})
export class DealSensitivityService {
    private readonly dealApiService = inject(DealApiService);

    public getSensitivityForDeal(dealId: number): Observable<DealSensitivityOverview> {
        return this.dealApiService.getSensitivityForDeal(dealId);
    }

    public computeSensitivitiesForDeal(dealId: number, request?: ComputeSensitivitiesRequest): Observable<DealSensitivityOverview> {
        return this.dealApiService.computeSensitivitiesForDeal(dealId, request);
    }

    public getSensitivityDetailsForDeal(dealId: number, dealSensitivityId: number): Observable<DealSensitivity> {
        return this.dealApiService.getSensitivityDetailsForDeal(dealId, dealSensitivityId);
    }
}
